// extracted by mini-css-extract-plugin
module.exports = {"lastRow":"styles_lastRow__yV5uO","btnNext":"styles_btnNext___XU0K","step":"styles_step__CMIJW","btnsWrapper":"styles_btnsWrapper__51svE","btnUnset":"styles_btnUnset__I8Wpf"};